import { render, staticRenderFns } from "./SbppsInstructorIcard.vue?vue&type=template&id=31fcab7c&scoped=true&"
import script from "./SbppsInstructorIcard.vue?vue&type=script&lang=js&"
export * from "./SbppsInstructorIcard.vue?vue&type=script&lang=js&"
import style0 from "./SbppsInstructorIcard.vue?vue&type=style&index=0&id=31fcab7c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31fcab7c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRadio } from 'vuetify/lib/components/VRadioGroup';
import { VRadioGroup } from 'vuetify/lib/components/VRadioGroup';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VBtn,VCard,VCol,VRadio,VRadioGroup,VRow,VSwitch,VTextarea})
